import TaskRewardsPage from "./TaskRewardsPage";

export default TaskRewardsPage;